/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'form'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'formDose'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'prescriptionType'?: ProductDtoPrescriptionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    'psychotropic'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductDtoPrescriptionTypeEnum {
    Rp = 'RP',
    Rpw = 'RPW',
    Rps = 'RPS',
    Lz = 'LZ',
    Rplz = 'RPLZ',
    Lzrp = 'LZRP',
    Xlz = 'XLZ',
    Xrplz = 'XRPLZ',
    Rpwlz = 'RPWLZ',
    Rpz = 'RPZ'
}


